import { writable } from 'svelte/store';
export const isLoading = writable(false);
export const isChanged = writable(false);
export const submitBtnText = writable('');
/**
 *==============================================================
 * If you don't want to run into issues with shallow copies,
 * avoid using defaults for arrays and/or objects.
 *
 * If you want to do it anyways, make sure that
 * you destructure them correctly. Good luck!
 *==============================================================
 */
export const DEFAULT_PLACE = -999;
export const DEFAULT_ROOM = 0;
export const DEFAULT_PRICE = 0;
export const DEFAULT_DATE = '';
/**
 * If you see errors in console about this being readonly,
 * then you are probably doing something wrong. In that case,
 * check the attributes that have a reference data type.
 */
const DEFAULT_DATA = Object.freeze({
    place: DEFAULT_PLACE,
    roomType: DEFAULT_ROOM,
    accommodationTypes: [],
    accommodationWith: [],
    priceFrom: DEFAULT_PRICE,
    priceTo: DEFAULT_PRICE,
    dateFrom: DEFAULT_DATE,
    dateTo: DEFAULT_DATE,
});
/**
 * @param state current store state
 * @param selected
 */
const remove = (state, selected) => {
    const { key, value, defaultValue } = selected;
    if (typeof key === 'object') {
        // removing dateFrom and dateTo in term
        key.forEach((_key) => state = remove(state, Object.assign(Object.assign({}, selected), { key: _key })));
        return state;
    }
    // removing an item from array (i.e. accommodation type)
    if (typeof DEFAULT_DATA[key] === 'object') {
        return Object.assign(Object.assign({}, state), { [key]: state[key].filter((item) => item !== value) });
    }
    // removing an item that has a dynamic default value (i.e. hory)
    if (defaultValue) {
        return Object.assign(Object.assign({}, state), { [key]: defaultValue });
    }
    // removing an item that has a static default value
    return Object.assign(Object.assign({}, state), { [key]: DEFAULT_DATA[key] });
};
const createFilters = () => {
    const { subscribe, set, update } = writable(Object.assign({}, DEFAULT_DATA));
    const resetTypeCategory = () => {
        update((value) => (Object.assign(Object.assign({}, value), { roomType: DEFAULT_ROOM, accommodationTypes: [], accommodationWith: [] })));
    };
    const resetLocationCategory = () => {
        update((value) => (Object.assign(Object.assign({}, value), { place: DEFAULT_PLACE })));
    };
    const resetPriceCategory = () => {
        update((value) => (Object.assign(Object.assign({}, value), { priceFrom: DEFAULT_PRICE, priceTo: DEFAULT_PRICE })));
    };
    const resetTermCategory = () => {
        update((value) => (Object.assign(Object.assign({}, value), { dateFrom: DEFAULT_DATE, dateTo: DEFAULT_DATE })));
    };
    const resetRegionCategory = (defaultHory) => {
        update((value) => (Object.assign(Object.assign({}, value), { hory: defaultHory })));
    };
    const removeAll = (selectedFilters) => {
        update((state) => {
            selectedFilters.forEach((filter) => state = remove(state, filter));
            return state;
        });
    };
    const removeFilter = (selected) => {
        update((state) => remove(state, selected));
    };
    return {
        subscribe,
        set,
        update,
        resetTypeCategory,
        resetLocationCategory,
        resetPriceCategory,
        resetTermCategory,
        removeAll,
        removeFilter,
        resetRegionCategory,
    };
};
export default createFilters();
